import { Link } from "@mui/material";
import { Button, useRecordContext } from "react-admin";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { ToolbarStyledButton } from "./ToolbarButton";
const userProfileURL = `${import.meta.env.VITE_FRONTEND_URL}/profile/`;

export const OpenProfileButton = (props: any) => {
    const record = useRecordContext(props);
    return (

        <ToolbarStyledButton
            component={Link}
            href={userProfileURL + record!.id}
            target="_blank"    
            label={"Open Profile"}

        >
            <OpenInNewIcon />
        </ToolbarStyledButton>
    )
}